import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ProductItems, ProductSliceProp } from "../../../types/Ecommerce";
import { Products } from "../../../jsonData";

const initialState: ProductSliceProp = {
  filterToggle: false,
  productItem: [],
};

export const fetchProductJsonData = createAsyncThunk<ProductItems[], void, {}>("/json-data/product", async () => {
  const response = await axios.get(Products);
  return response.data;
});

const ProductSlice = createSlice({
  name: "ProductSlice",
  initialState,
  reducers: {
    setFilterToggle: (state) => {
      state.filterToggle = !state.filterToggle;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProductJsonData.fulfilled, (state, action) => {
      state.productItem = action.payload;
    });
  },
});
export const { setFilterToggle } = ProductSlice.actions;

export default ProductSlice.reducer;
